import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export type {
  GetWalletResponse,
  WalletRecoveryState,
} from '@dynamic-labs-wallet/browser-wallet-client';
export { NotWaasWalletProviderError } from '../errors/NotWaasWalletProviderError';
export { backupWaasKeySharesToGoogleDrive } from '../modules/waas/backupWaasKeySharesToGoogleDrive';
export { createWaasWalletAccounts } from '../modules/waas/createWaasWalletAccounts';
export { delegateWaasKeyShares } from '../modules/waas/delegateWaasKeyShares';
export { exportWaasClientKeyshares } from '../modules/waas/exportWaasClientKeyshares';
export { exportWaasPrivateKey } from '../modules/waas/exportWaasPrivateKey';
export { getChainsMissingWaasWalletAccounts } from '../modules/waas/getChainsMissingWaasWalletAccounts';
export { getWalletRecoveryState } from '../modules/waas/getWalletRecoveryState';
export { hasDelegatedAccess } from '../modules/waas/hasDelegatedAccess';
export { importWaasPrivateKey } from '../modules/waas/importWaasPrivateKey';
export { isDynamicWaasEnabled } from '../modules/waas/isDynamicWaasEnabled';
export { isPasswordRequiredForWaasWallets } from '../modules/waas/isPasswordRequiredForWaasWallets';
export { isWaasWalletAccount } from '../modules/waas/isWaasWalletAccount';
export { isWalletCreationRequirement } from '../modules/waas/isWalletCreationRequirement/isWalletCreationRequirement';
export { normalizeWalletRequirements } from '../modules/waas/normalizeWalletRequirements/normalizeWalletRequirements';
export { refreshWaasWalletAccountShares } from '../modules/waas/refreshWaasWalletAccountShares';
export { revokeWaasDelegation } from '../modules/waas/revokeWaasDelegation';
export { setWaasWalletAccountPassword } from '../modules/waas/setWaasWalletAccountPassword';
export { shouldAutoCreateWalletForChain } from '../modules/waas/shouldAutoCreateWalletForChain';
export { unlockWallet } from '../modules/waas/unlockWallet';
export { updateWaasPassword } from '../modules/waas/updateWaasPassword';
export type {
  WalletCreationBitcoinConfig,
  WalletCreationRequirement,
} from '../modules/waas/waas.types';
